exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* TODO: Use max-height prop when gitlab-ui got updated.\nSee https://gitlab.com/gitlab-org/gitlab-services/design.gitlab.com/-/issues/2472 */\n[data-v-1cbb28ca] .gl-new-dropdown-inner {\n  max-height: 310px !important;\n}\n", ""]);

